:host {
	display: block;
	margin: 1em auto;
	width: 60%;
}
